<template>
  <CampaignCouponDiscountList />
</template>

<script>
import CampaignCouponDiscountList from "@/components/CampaignCouponDiscountList.vue";

export default {
  name: "CampaignCouponDiscountListView",
  components: {
    CampaignCouponDiscountList,
  },
};
</script>